<template>
  <section>
    <!-- Componentes externos -->
    <FinalizarProgramacionRRHH />
    <RechazarProgramacionRRHH />
    <FinalizarProgramacionesFuncionarios />
    <VerDetalleSolicitudes />
    <VerDetalleSolicitudesProgramacion />
    <EnviarProgramacion />
    <EditarDiasReserva/>
    <h3 class="primary--text">
      <v-icon color="primary">event</v-icon> Programación de vacaciones
      {{ periodo }} 
    </h3>
    <v-flex class="px-3">
      <v-tooltip bottom>
        <v-btn
          color="primary"
          :to="
            `/vacaciones-listado-unidades/${this.$util.decodeString(
              this.$route.params.gestion
            )}`
          "
          slot="activator"
          ><v-icon dark>arrow_back</v-icon> ATRAS</v-btn
        >
        <span>Atras</span>
      </v-tooltip>
    </v-flex>
    <v-card>
      <v-card-text>
        <strong>AÑO DE PROGRAMACIÓN : </strong>
        {{ this.$util.decodeString($route.params.gestion) }}
        <br />
        <strong>DEPENDENCIA : </strong>{{ nombre_unidad }}
        <!-- Boton validar dependencia  -->
        <!-- <v-tooltip>
          <v-btn
            color="rgba(156, 80, 162 ,0.3)"
            @click.prevent="finalizarProgramacionesFuncionarios({})"
            slot="activator"
            ><v-icon dark>done</v-icon>Finalizar programaciones
          </v-btn>
          <span>Finalizar programaciones</span>
        </v-tooltip> -->
      </v-card-text>
      <v-card-text>
        <v-data-table
          class="elevation-1 tabla-comprimida-light"
          :headers="headers"
          :items="lista_funcionarios_vacaciones"
          no-data-text="Sin datos"
          item-key="id"
          :search="filters"
          :custom-filter="customFilter"
          no-results-text="No se encontro coincidencias"
          :rows-per-page-items="[25, 50, { text: 'Todos', value: -1 }]"
        >
          <!-- Cabecera -->
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on" class="letra-cabecera">
                  {{ props.header.text }}
                </span>
              </template>
              <span>
                {{ props.header.text }}
              </span>
            </v-tooltip>
          </template>

          <template v-slot:items="items">
            <td class="text-xs-center">{{ items.item.servidor_publico }}</td>
            <td class="text-xs-center">
              {{ $moment(items.item.fecha_incorporacion).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">{{ items.item.dias_saldo_a }}</td>
            <td class="text-xs-center">{{ items.item.dias_saldo_b }}</td>
            <td class="text-xs-center">{{ items.item.dias_saldo_c }}</td>
            <td class="text-xs-center">{{ items.item.total_dias_saldo }}</td>
            <td class="text-xs-center">{{ items.item.dias_programar }}</td>
            <td class="text-xs-center">{{ items.item.dias_no_programados }}</td>
            <td class="text-xs-center">{{ items.item.ene }}</td>
            <td class="text-xs-center">{{ items.item.feb }}</td>
            <td class="text-xs-center">{{ items.item.mar }}</td>
            <td class="text-xs-center">{{ items.item.abr }}</td>
            <td class="text-xs-center">{{ items.item.may }}</td>
            <td class="text-xs-center">{{ items.item.jun }}</td>
            <td class="text-xs-center">{{ items.item.jul }}</td>
            <td class="text-xs-center">{{ items.item.ago }}</td>
            <td class="text-xs-center">{{ items.item.sep }}</td>
            <td class="text-xs-center">{{ items.item.oct }}</td>
            <td class="text-xs-center">{{ items.item.nov }}</td>
            <td class="text-xs-center">{{ items.item.dic }}</td>
            <td class="text-xs-center">{{ items.item.estado }}</td>
            <td>
              <v-btn
                v-if="items.item.id_estado_vacac_progra != 22"
                color="#95c2f9"
                :to="
                  `/programacion-funcionario-RRHH/${$util.decodeString(
                    $route.params.gestion
                  )}/${items.item.id_persona}`
                "
                dark
                icon
                title="Ver programaciones"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
              <v-btn
                v-if="items.item.id_estado_vacac_progra != 22"
                color="#0594A5"
                dark
                @click.prevent="verDetalleProgramacion(items.item)"
                icon
                title="Ver detalle"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
              <v-btn
                v-if="items.item.id_estado_vacac_progra != 22"
                color="#6DE0BA"
                dark
                @click.prevent="verDetalle(items.item)"
                icon
                title="Descripción"
              >
                <v-icon>receipt</v-icon>
              </v-btn>
              <!--  Aprobar programacion de LA VACACION-->
              <v-btn
                v-if="
                  items.item.id_estado_vacac_progra == 51 ||
                    items.item.id_estado_vacac_progra == 73
                "
                color="#44deaa"
                dark
                @click.prevent="aprobarProgramacionInicialRRHH(items.item)"
                icon
                title="Aprobar programación de vacación"
              >
                <v-icon>done</v-icon>
              </v-btn>
              <!-- Boton para rechazar la programacion-->
              <v-btn
                color="#FF5D34"
                dark
                v-if="
                  items.item.id_estado_vacac_progra == 54 ||
                    items.item.id_estado_vacac_progra == 66 ||
                    items.item.id_estado_vacac_progra == 51 ||
                    items.item.id_estado_vacac_progra == 73
                "
                @click.prevent="rechazarProgramacionRRHH(items.item)"
                icon
                title="Rechazar  programación de vacación"
              >
                <v-icon>close</v-icon>
              </v-btn>
              <!-- ENVIAR JEFE SIN IMPORTAR SI PROGRAMO O NO -->
              <v-btn
                v-if="items.item.id_estado_vacac_progra == 22"
                @click.prevent="enviarProgramacion(items.item)"
                color="indigo"
                dark
                icon
                title="Enviar programacion"
              >
                <v-icon>send</v-icon>
              </v-btn>
              <!-- boton editar dias reserva y ver informacion de programacion del servidor-->
              <v-btn
                color="rgb(147,13,242)"
                dark
                @click.prevent="editarDiasReserva(items.item)"
                icon
                title="Modificar días de reserva"
              >
                <v-icon>edit</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import FinalizarProgramacionRRHH from "./dialogs/FinalizarProgramacionRRHH.vue";
import RechazarProgramacionRRHH from "./dialogs/RechazarProgramacionRRHH.vue";
import FinalizarProgramacionesFuncionarios from "./dialogs/FinalizarProgramacionesFuncionarios.vue";
import filtros from "./mixins/filtros";
import VerDetalleSolicitudes from "./dialogs/VerDetalleSolicitudes";
import VerDetalleSolicitudesProgramacion from "./dialogs/VerDetalleSolicitudesProgramacion";
import EnviarProgramacion from "./dialogs/EnviarProgramacion.vue";
import EditarDiasReserva from "./dialogs/EditarDiasReservaOtros.vue"

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud, filtros],

  // Variables iniciales del componente
  data() {
    let user = this.$storage.get("user");
    return {
      periodo: parseInt(this.$util.decodeString(this.$route.params.gestion)),
      lista_funcionarios_vacaciones: [],
      nombre_unidad: null,
      dias_reserva:0,
      // Variables filtros
      filterShow: true,
      filters: {
        servidor_publico: "",
        fecha_incorporacion: "",
        saldo_corte: "",
        dias_asignados: "",
        dias_programar: ""
      },
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      nro_item: null,
      persona: null,
      loading: false
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "Servidor público",
          value: "id",
          align: "center"
        },
        {
          text: "Fecha de incorporación",
          value: "fecha_solicitud",
          align: "center"
        },
        {
          text: `SALDO DE VACACION PERIODO ${this.periodo - 3}-${this.periodo -
            2}\n(A)`,
          value: "dias_saldo_a",
          align: "center"
        },
        {
          text: `SALDO DE VACACION PERIODO ${this.periodo - 2}-${this.periodo -
            1}\n(B)`,
          value: "dias_saldo_b",
          align: "center"
        },
        {
          text: `SALDO DE VACACION PERIODO ${this.periodo - 1}-${
            this.periodo
          }\n(C)`,
          value: "dias_saldo_c",
          align: "center"
        },
        {
          text: `TOTAL DIAS\n(A+B+C)`,
          value: "total_dias_saldo",
          align: "center"
        },
        {
          text: `TOTAL DIAS PROGRAMADOS DE ACUERDO A PORCENTAJE`,
          value: "dias_programar",
          align: "center"
        },
        {
          text: `TOTAL DIAS NO PROGRAMADOS`,
          value: "dias_no_programados",
          align: "center"
        },
        { text: "Ene", value: "ene", align: "center" },
        { text: "Feb", value: "feb", align: "center" },
        { text: "Mar", value: "mar", align: "center" },
        { text: "Abr", value: "abr", align: "center" },
        { text: "May", value: "may", align: "center" },
        { text: "Jun", value: "jun", align: "center" },
        { text: "Jul", value: "jul", align: "center" },
        { text: "Ago", value: "ago", align: "center" },
        { text: "Sep", value: "sep", align: "center" },
        { text: "Oct", value: "oct", align: "center" },
        { text: "Nov", value: "nov", align: "center" },
        { text: "Dic", value: "dic", align: "center" },
        {
          text: `Estado`,
          value: "estado",
          align: "center"
        },
        {
          text: this.$t("common.actions"),
          sortable: false,
          align: "center"
        }
      ];
    }
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    this.getAño();
    this.nombre_unidad = await this.obtenerNombreUnidad();
    await this.cargarProgramacionesGeneral();
    //this.es_vice_min = await this.compruebaViceMin();
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    this.onFilter();
    this.$bus.$on("closeDialog", () => {
      this.updateList();
    });
    this.$bus.$on("closeDialogFinalizarProgramacionRRHH", async () => {
      this.getAño();
      await this.cargarProgramacionesGeneral();
    });
    this.$bus.$on("closeDialogFinalizarProgramacionFuncionarios", async () => {
      this.getAño();
      await this.cargarProgramacionesGeneral();
    });
    this.$bus.$on("closeDialogEnviarProgramacion", async () => {   
      this.getAño();
      await this.cargarProgramacionesGeneral();
    });
    this.$bus.$on("closeDialogEditarDiasReserva", async () => {
      this.getAño();
      await this.cargarProgramacionesGeneral();
    });

  },
  // Métodos y funciones del componente
  methods: {
    // MEtodo para enviar la programacion de vacaciones sin restricciones
    async enviarProgramacion(item) {
      item.id_estado_vacacion = await this.obtenerIdEStadoVacacion(
        item.id_persona
      );
      this.$bus.$emit("openDialogEnviarProgramacion", item);
    },
    getAño() {
      let año = this.$util.decodeString(parseInt(this.$route.params.gestion));
      return año;
    },
    async obtenerIdEStadoVacacion(id_persona) {
      try {
        let id_estado_vacacion = 0;

        let res = await this.$service.graphql({
          query: `
							query{
                  vEstadoVacacions(id_persona:${parseInt(
                    id_persona
                  )},periodo:"${this.periodo}"){
                    rows{
                       nombre
                        dias_saldo
                        dias_asignados
                        dias_utilizados
                        dias_programados
                        dias_cta_vacacion
                        id
                        id_estado
                        id_persona
                        nombre
                        ingreso
                        gestion_desde
                        gestion_hasta
                        periodo
                        estado
                        cas
                        dias_a_programar
                        total_dias_saldo
                        saldo_a_programar
                        dias_reserva
                    }
                  }
                }
					`
        });
        if (res.vEstadoVacacions.rows.length > 0) {
          id_estado_vacacion = res.vEstadoVacacions.rows[0].id;
          this.dias_reserva=res.vEstadoVacacions.rows[0].dias_reserva
          return id_estado_vacacion;
        }
        return id_estado_vacacion;
      } catch (error) {
        console.log(error);
      }
    },
    async aprobarProgramacionInicialRRHH(item) {
      try {
        this.$confirm(
          "¿Esta seguro(a) que desea aprobar la  programación?",
          async () => {
            let user = this.$storage.get("user");
            let id_estado_vacacion = await this.obtenerIdEStadoVacacion(
              item.id_persona
            );
            let res = await this.$service.graphql({
              query: `
              query{
                runQuery(consulta: "SELECT vacaciones.fn_aprueba_vacacion_programada_por_servidor_rrhh(${parseInt(
                  id_estado_vacacion
                )},66,${user.id_persona},${user.id})"){
                  respuesta
                }
              }
            `
            });
            res =
              res.runQuery.respuesta[0]
                .fn_aprueba_vacacion_programada_por_servidor_rrhh;
            let rpta = res.split("|");

            if (rpta[0] == "1") {
              this.$confirm("La programación fué aprobada", async () => {
                await this.cargarProgramacionesGeneral();
              });
            } else {
              this.$confirm(resps[1], async () => {
                //await this.cargarProgramacionesGeneral();
              });
            }
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    async compruebaViceMin() {
      try {
        let es_especial = false;
        let res;

        res = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta: "SELECT movilidad.fn_pregunta_cargo_viceministros(${parseInt(
                  this.$util.decodeString(this.$route.params.item_jefe)
                )})"){
                  respuesta
                }
              }
            `
        });
        res = res.runQuery.respuesta[0].fn_pregunta_cargo_viceministros;
        if (res) {
          res = res.split("|");
          if (parseInt(res[0]) == 1) {
            if (res[1] == "SI") {
              es_especial = true;
            }
          } else {
            this.$message.error(res[1]);
          }
        }
        return es_especial;
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerNombreUnidad() {
      let id_unidad = this.$util.decodeString(this.$route.params.id_unidad);
      try {
        let rpta = await this.$service.graphql({
          query: `
						query{
              unidads(id:${parseInt(id_unidad)}){
                rows{
                  id
                  id_estado
                  nombre_unidad
                }
              }
            }
					`
        });
        if (rpta.unidads.rows.length != 0) {
          return rpta.unidads.rows[0].nombre_unidad;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async cargarProgramacionesGeneral() {
      try {
        let res = [];
        let p_tipo_jefe = this.$util.decodeString(this.$route.params.tipo_jefe);
        let p_gestion = this.$util.decodeString(this.$route.params.gestion);
        let p_id_unidad = this.$util.decodeString(this.$route.params.id_unidad);
        let p_id_persona = this.$util.decodeString(
          this.$route.params.id_persona
        );
        if (p_tipo_jefe) {
          if (p_tipo_jefe == "AUT") {
            res = await this.$service.graphql({
              query: `
							query{
							runQuery(consulta:"SELECT * FROM vacaciones.fn_vacaciones_por_unidad_jerarquicos(${p_id_unidad},${p_gestion},${p_id_persona})AS(id_unidad integer,servidor_publico TEXT,fecha_incorporacion date,saldo_corte NUMERIC,dias_saldo_a NUMERIC,dias_saldo_b NUMERIC,dias_saldo_c NUMERIC,	total_dias_saldo numeric,dias_no_programados numeric,dias_asignados NUMERIC,vac_adquirida varchar,dias_programar varchar,total_programacion NUMERIC,ene TEXT,feb TEXT,mar TEXT,abr TEXT,may TEXT,jun TEXT,jul TEXT,ago TEXT,sep TEXT,oct TEXT,nov TEXT,dic TEXT,estado TEXT,id_estado_vacac_progra INTEGER,id_persona integer)"){
								respuesta
							}
							}
						`
            });
          } else {
            res = await this.$service.graphql({
              query: `
							query{
							runQuery(consulta:"SELECT * FROM vacaciones.fn_vacaciones_por_unidad(${p_id_unidad},${p_gestion})AS(id_unidad integer,servidor_publico TEXT,fecha_incorporacion date,saldo_corte NUMERIC,dias_saldo_a NUMERIC,dias_saldo_b NUMERIC,dias_saldo_c NUMERIC,	total_dias_saldo numeric,dias_no_programados numeric,dias_asignados NUMERIC,vac_adquirida varchar,dias_programar varchar,total_programacion NUMERIC,ene TEXT,feb TEXT,mar TEXT,abr TEXT,may TEXT,jun TEXT,jul TEXT,ago TEXT,sep TEXT,oct TEXT,nov TEXT,dic TEXT,estado TEXT,id_estado_vacac_progra INTEGER,id_persona integer)"){
								respuesta
							}
							}
						`
            });
          }
          res = res.runQuery.respuesta;
          this.lista_funcionarios_vacaciones = res;
        }
      } catch (error) {
        console.log(error);
      }
    },
    finalizarProgramacionRRHH(item) {
      this.$bus.$emit("openDialogFinalizarProgramacionRRHH", item);
    },
    rechazarProgramacionRRHH(item) {
      this.$bus.$emit("openDialogRechazarProgramacionRRHH", item);
    },
    async finalizarProgramacionesFuncionarios(item) {
      item.nombre_unidad = this.nombre_unidad;
      this.$bus.$emit("openDialogFinalizarProgramacionesFuncionarios", item);
    },
    // Metodo para abrir dialog detalle
    async verDetalle(item) {
      item.periodo = this.periodo
      item.id_estado_vacacion = await this.obtenerIdEStadoVacacion(
        item.id_persona
      );
      this.$bus.$emit("openDialogVerDetalleSolicitudes", item);
    },
    verDetalleProgramacion(item) {
      this.$bus.$emit("openDialogVerDetalleSolicitudesProgramacion", item);
    },
    async editarDiasReserva(item){
      item.gestion=this.periodo
      //obtenemos el id de la tbla estado_vacacion:
      let estado_vacacion = await this.$query.select(
          "v_estado_vacacion",
          {
            id_persona: item.id_persona,
            gestion_hasta: this.periodo + ""
          },
          ["id", "id_estado", "id_estado_programacion"]
        );
        estado_vacacion = estado_vacacion[0];
        item.id_estado_vacacion=estado_vacacion.id
        await this.obtenerIdEStadoVacacion(item.id_persona);
        item.dias_reserva=this.dias_reserva
      this.$bus.$emit("openDialogEditarDiasReserva", item);
    },
  },

  // Definición de componentes importados
  components: {
    CrudTable,
    FinalizarProgramacionRRHH,
    RechazarProgramacionRRHH,
    FinalizarProgramacionesFuncionarios,
    VerDetalleSolicitudes,
    VerDetalleSolicitudesProgramacion,
    EnviarProgramacion,
    EditarDiasReserva,
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/ListadoFuncionariosRRHHVacaciones.vue